import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

// TODO: Replace this component usage with CSelect component

export default /*#__PURE__*/_defineComponent({
  __name: 'CDropdown',
  props: {
    placeholder: { default: 'Select an option' },
    options: null,
    value: null,
    name: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { placeholder: string, options: { value: unknown; text: string }[], value: unknown, name: string };





const vmodel = computed({
    get: () => props.value,
    set: (value) => {
        emit('input', value);
    }
});

return { __sfc: true,props, emit, vmodel }
}

})